export const REFRESH_SS_KEY_META = '_refreshing';

export const checkIsRefresh = (): boolean => {
  const navEntries = performance.getEntriesByType('navigation');
  // @ts-ignore
  const type = navEntries[0]?.type || 'navigate';
  const wasRefreshed = sessionStorage.getItem(REFRESH_SS_KEY_META) === '1';
  sessionStorage.removeItem(REFRESH_SS_KEY_META);

  return type === 'reload' || wasRefreshed;
};
